module.exports = __webpack_public_path__ + "static/media/seja-parceiro.2e312ea5.png";